import styled from 'styled-components';

const StyledSearchBar = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
`;
const StyledSearchInput = styled.input `
  width: 100%;
  padding: 1rem 3.5rem 1rem 1.25rem;
  border: 1px solid ${props => props.theme.colors.darkGray};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.backgroundColor};
  color: ${props => props.theme.colors.textColor};
  font-size: ${props => props.theme.typography.text.regular.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.regular};
  outline: none;
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard};
  box-shadow: 0 0 0 0 ${props => props.theme.colors.darkGray}20;

  &::placeholder {
    color: ${props => props.theme.colors.mutedTextColor};
    opacity: 0.7;
  }

  &:focus {
    border-color: ${props => props.theme.colors.mist};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.mist}40,
      0 0 12px ${props => props.theme.colors.mist}50, 0 0 20px ${props => props.theme.colors.mist}30;
  }

  &:hover:not(:focus) {
    border-color: ${props => props.theme.colors.darkGrayShade};
    box-shadow: 0 0 8px ${props => props.theme.colors.darkGray}30;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: ${props => props.theme.colors.mutedBackgroundColor};
    box-shadow: none;
  }

  /* Prevent browser autofill from changing background color */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${props => props.theme.colors.backgroundColor} inset !important;
    -webkit-text-fill-color: ${props => props.theme.colors.textColor} !important;
    background-color: ${props => props.theme.colors.backgroundColor} !important;
    background: ${props => props.theme.colors.backgroundColor} !important;
    border-radius: 8px;
  }

  /* Firefox autofill prevention */
  &:-moz-autofill {
    background-color: ${props => props.theme.colors.backgroundColor} !important;
    background: ${props => props.theme.colors.backgroundColor} !important;
    border-radius: 8px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0.875rem 3rem 0.875rem 1rem;
    font-size: ${props => props.theme.typography.text.small.fontSize};
  }
`;
const StyledSearchIcon = styled.button `
  position: absolute;
  right: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: ${props => props.theme.colors.iconColor};
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    color: ${props => props.theme.colors.mist};
    background-color: ${props => props.theme.colors.darkGray}20;
  }

  &:active:not(:disabled) {
    transform: translateY(-50%) scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    right: 1rem;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;
const StyledCloseIcon = styled.button `
  position: absolute;
  right: -0.5rem;
  top: -0.5rem;
  background: ${props => props.theme.colors.backgroundColor};
  border: 1px solid ${props => props.theme.colors.darkGray};
  color: ${props => props.theme.colors.iconColor};
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  z-index: 10;

  &:hover:not(:disabled) {
    border-color: ${props => props.theme.colors.darkGrayShade};
    box-shadow: 0 0 8px ${props => props.theme.colors.darkGray}30;
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    width: 22px;
    height: 22px;
    right: -0.4rem;
    top: -0.4rem;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export { StyledCloseIcon, StyledSearchBar, StyledSearchIcon, StyledSearchInput };
//# sourceMappingURL=SearchBar.styles.mjs.map
